module.exports = __webpack_public_path__ + "static/img/10.055ecc7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/zh/10.png
// module id = +zUC
// module chunks = 0